<template>
  <div class="main-content">
    <div class="page-header">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">Catalogue</li>
        <li class="breadcrumb-item"><router-link :to="{name: 'catalogue-types'}">Categories</router-link></li>
        <li class="breadcrumb-item active">New category</li>
      </ol>
    </div>
    <form
      v-if="$store.state.permissions.create.catalogue_categories"
      action="/api/admin/catalogue/types/save"
      method="POST"
      @submit.prevent="createType()"
    >
      <div class="card">
        <div class="card-body">
          <h3 class="page-title">Create new catalogue category</h3>
          <div class="form-group custom-control custom-checkbox">
            <input id="active" v-model="type.active" type="checkbox" class="custom-control-input" >
            <label class="custom-control-label" for="active">Active</label>
          </div>
          <div class="form-group">
            <label>Title</label>
            <input
              :class="{ 'is-invalid': $v.type.title.$error }"
              v-model.trim="type.title"
              class="form-control"
              @input="$v.type.title.$touch()"
            >
            <div v-if="$v.type.title.$error">
              <span
                v-if="!$v.type.title.required"
                class="help-block help-block-error"
              >Field is required</span>
              <span
                v-if="!$v.type.title.minLength"
                class="help-block help-block-error"
              >Title must have at least {{ $v.type.title.$params.minLength.min }} letters.</span>
            </div>
          </div>
          <div class="form-group">
            <label>Slug (leave empty for automatic generation)</label>
            <input v-model.trim="type.slug" class="form-control" >
          </div>
          <div class="form-group">
            <label>Main image</label>
            <br >
            <img-inputer
              v-model="type.main"
              :img-src="mainImg"
              exceed-size-text="Size of the file should be less than "
              theme="light"
              size="large"
              accept="image/*"
            />
            <br >
            <button type="button" class="btn btn-danger" @click="type.main = null">Clear</button>
          </div>
          <div class="form-group">
            <label>Description</label>
            <quill-editor ref="descriptionEditor" v-model="type.description"/>
          </div>
          <div class="form-group custom-control custom-checkbox">
            <input id="display_products" v-model="type.display_products" type="checkbox" class="custom-control-input" >
            <label class="custom-control-label" for="display_products">Display products</label>
          </div>
          <div class="form-group">
            <label>Bottom description</label>
            <quill-editor ref="bottomDescriptionEditor" v-model="type.bottom_description"/>
          </div>
          <div class="form-group">
            <label>Related drug form</label>
            <multiselect
              v-model="type.drug_form"
              :options="forms"
              :multiple="false"
              track-by="id"
              label="title"
            />
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-10">
              <h3 class="page-title">Product info</h3>
            </div>
            <div class="col-2">
              <button type="button" class="btn btn-success" @click="addNewSection">Add section</button>
            </div>
          </div>
          <div v-if="type.product_info.length" class="row">
            <div v-for="(section, key) in type.product_info" :key="key" class="col-xl-12">
              <div :id="(type.product_info.length > 2 && type.product_info.length - 1 == key ) ? 'last--section' : ''" class="card">
                <div class="card-body">
                  <div class="form-group">
                    <label>Section name</label>
                    <input v-model.trim="section.title" class="form-control" >
                  </div>
                  <div v-for="(row, rkey) in section.rows" :key="rkey" class="row">
                    <div class="col-5">
                      <input v-model.trim="row.title" class="form-control" >
                    </div>
                    <div class="col-6">
                      <quill-editor v-model="row.value"/>
                    </div>
                    <div class="col-1">
                      <button
                        type="button"
                        class="btn btn-danger"
                        @click="removeRow(key, rkey)"
                      >-</button>
                    </div>
                  </div>
                  <button type="button" class="btn btn-success" @click="addRow(key)">Add row</button>
                  <button
                    type="button"
                    class="btn btn-danger"
                    @click="removeSection(key)"
                  >Remove section</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="card">
        <div class="card-body">
          <button type="button" class="btn btn-primary" @click="goBack">Back</button>
          <button type="submit" class="btn btn-success">Create</button>
        </div>
      </div>
    </form>
    <div v-else class="card">
      <div class="card-header">
        <h3>You have not permission for do that</h3>
      </div>
    </div>
  </div>
</template>

<script>
/* global axios, toastr */
import Multiselect from 'vue-multiselect'
import { required, minLength } from 'vuelidate/lib/validators'
export default {
  name: 'CatalogueTypesCreate',
  components: { Multiselect },
  data () {
    return {
      type: {
        active: true,
        product_info: []
      },
      forms: []
    }
  },
  validations: {
    type: {
      title: {
        required,
        minLength: minLength(4)
      }
    }
  },
  computed: {
    mainImg: function () {
      if (typeof this.type.main === 'string') {
        return this.type.main
      }
      return null
    }
  },
  created () {
    axios
      .get('/api/public/drug-form')
      .then(repsonse => {
        this.forms = repsonse.data.forms.filter(item => item.id !== 0).map(item => {
          return {
            id: item.id,
            title: item.name,
            unit: item.unit
          }
        })
      })
      .catch(error => {
        console.log(error)
      })
  },
  methods: {
    createType () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        let formData = new FormData()
        for (var key in this.type) {
          if (key === 'product_info' || key === 'drug_form') {
            formData.append(key, JSON.stringify(this.type[key]))
          } else {
            formData.append(key, this.type[key])
          }
        }

        axios
          .post('/api/admin/catalogue/types/save', formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })
          .then(response => {
            if (response && response.data && response.data.result === 'ok') {
              this.type = response.data.type
              toastr['success']('Category has been created successfully')
            } else {
              let message =
                (response && response.data && response.data.message) ||
                'Something goes wrong'
              toastr['error'](message)
            }
          })
          .catch(error => {
            let message = (error && error.message) || 'Something goes wrong'
            toastr['error'](message)
          })
      }
    },
    addNewSection () {
      let that = this
      let newProductInfo = this.type.product_info
      newProductInfo.push({
        title: 'New section',
        rows: []
      })
      this.type.product_info = newProductInfo
      this.$nextTick().then(() => {
        if (that.type.product_info.length > 2) {
          document.getElementById('last--section').scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' })
        }
      })
    },
    removeSection (id) {
      let newProductInfo = this.type.product_info
      newProductInfo.splice(id, 1)
      this.type.product_info = newProductInfo
    },
    addRow (id) {
      let newProductInfo = this.type.product_info
      newProductInfo[id].rows.push({
        title: '',
        value: ''
      })
      this.type.product_info = newProductInfo
    },
    removeRow (section, row) {
      let newProductInfo = this.type.product_info
      newProductInfo[section].rows.splice(row, 1)
      this.type.product_info = newProductInfo
    },
    goBack () {
      this.$router.push('/admin/catalogue/types')
    }
  }
}
</script>

<style>
</style>
